import React from 'react';

import { LoginForm } from '@/routes/(auth)/components/login-form';

const Login = () => <LoginForm />;

export default Login;
